'use strict';
function get_elem($translate) {
    var elements = [
        {
            type: 'justify',
            label: 'Espacio',
        },
        {
            type: 'title',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.TITLE'),
            notaSize:11,fontSize:18,logoSize:40, 
            fontColor:"#333",fontColorNota:"#333",backgroundColor:"#fff",
            textAlign:'left',logoPosition:"right"
        }, {
            type: 'date',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.DATE'),

        }, {
            type: 'select',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.SELECT'),
            templateData: {
                optionsType: 'static',
                options: [],
                datasource: {
                    type: 'distinct',
                    formId: '',
                    element: {},
                },
                optionsAsButtons: false
            }
        }, {
            type: 'datasource',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.DATASOURCE'),
            templateData: {
                datasource: {
                    type: 'query',
                    formId: '',
                    elements: {},
                },

            }
        }, {
            type: 'pivotChart',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.PIVOTCHART'),
            templateData: {
                datasourceElementId: undefined

            }
        }, {
            type: 'grid',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.GRID'),
            templateData: {
                datasourceElementId: undefined

            }
        }, {
            type: 'map',
            label: $translate.instant('DASHBOARD.DASH_BUILDER.ELEMENTS.MAP'),
            templateData: {
                datasourceElementId: undefined,
                columnName: undefined,
                columnCoords: undefined
            }
        }
    ];


    elements.sort(function (a, b) {
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        // names must be equal
        return 0;
    });
    return elements
}
module.exports = get_elem;
